import lozad from 'lozad'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes'

lozad(
  'img[data-src]:not([data-sizes]), video[data-src], [data-background-image]'
).observe()
